import React, { useEffect } from 'react';

const Impact = () => {
  useEffect(() => { document.title = 'Impact | Afterimage Labs'; }, []);

  return (
    <main>
      <section className="ai-pagehead">
        <div className="ai-wrap">
          <h1>Diagnostic error is common. A careful look at it is rare.</h1>
          <p>
            A late diagnosis can turn a treatable illness into a permanent one. Very
            few of those cases are ever looked at again.
          </p>
        </div>
      </section>

      <section className="ai-section">
        <div className="ai-wrap">
          <h2>The numbers</h2>
          <ul className="ai-figures">
            <li>
              <b>20%</b>
              of patients experience a diagnostic error during their care. Most are
              minor.
            </li>
            <li>
              <b>1 million+</b>
              patients a year are permanently disabled or killed by diagnostic errors.
              Only 5,000 to 10,000 cases are investigated.
            </li>
            <li>
              <b>$300 billion+</b>
              in preventable costs from medical errors lands on patients and insurers
              every year.
            </li>
          </ul>
        </div>
      </section>

      <section className="ai-section">
        <div className="ai-wrap">
          <h2>Where people get stuck</h2>
          <div>
            <p className="ai-statement">
              Most of these cases are decided before anyone reads the chart.
            </p>
            <div className="ai-body">
              <p>
                Investigating a case costs a lot up front and often goes nowhere, so
                attorneys turn down most of them before anyone has read the chart.
                Patients don't know how to get their records or what to look for once
                they have them. Hospitals rarely review a case unless someone raises
                it. Each of those is a reason a real error never gets looked at, and
                a reason a weak claim isn't ruled out early.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="ai-section">
        <div className="ai-wrap">
          <h2>What changes</h2>
          <div className="ai-pairs">
            <div>
              <h3>For patients</h3>
              <ul>
                <li>Your records, collected for you, including the ones that are hard to get</li>
                <li>A clear answer about whether a diagnosis was missed</li>
                <li>A written review you can take to a doctor or an attorney</li>
              </ul>
            </div>
            <div>
              <h3>For attorneys</h3>
              <ul>
                <li>Complete records without the chase</li>
                <li>A timeline of the care built from every page</li>
                <li>An early, honest read on whether a case holds up</li>
              </ul>
            </div>
            <div>
              <h3>For health systems</h3>
              <ul>
                <li>Recurring failures spotted before they hurt more people</li>
                <li>Specific findings a quality team can act on</li>
                <li>Less malpractice exposure over time</li>
                <li>Better outcomes, and patients who trust you more</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Impact;
